import React from 'react'
import { Investment } from '../../../../app/models/Investment/Investment'
import InvestorHeader from './InvestorHeader';
import InvestorGrid from './InvestorGrid';

interface Props {
    investment: Investment;
}

function InvestorInfo({ investment }: Props) {
    return (
        <>
            <InvestorHeader investment={investment} />

            <InvestorGrid investment={investment} onApproval={() => { }} />
        </>
    )
}

export default InvestorInfo